const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/spaces/$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";

// Catch sub-paths like /new, /new_space_group, /:slug/edit
// These paths trigger modals via URL-detection hooks within the Spaces component
export const Route = createFileRoute("/_protected/_settingsLayout/settings/spaces/$")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});